import { StyledIcon } from "@styled-icons/styled-icon";
import React from "react";
import styled from "styled-components";
import { ButtonProps } from "types/ButtonProps";

import { Button } from "./Button";

interface MyButtonProps {
  Icon: StyledIcon;
  accentColor?: string;
  withShadow?: boolean;
}

type BaseButtonProps = MyButtonProps & ButtonProps;

export const IconButton = React.forwardRef<HTMLButtonElement, BaseButtonProps>(
  ({ Icon, accentColor = "var(--widget-primary)", withShadow = true, ...props }, ref) => {
    return (
      <OuterContainer ref={ref} backgroundColor="white" {...props} withShadow={withShadow}>
        <Icon width="100%" height="100%" color={accentColor} />
      </OuterContainer>
    );
  },
);

export const IconButtonInverted = React.forwardRef<HTMLButtonElement, BaseButtonProps>(
  ({ Icon, accentColor = "var(--primary)", withShadow = true, ...props }, ref) => {
    return (
      <OuterContainer ref={ref} backgroundColor={accentColor} {...props} withShadow={withShadow}>
        <Icon width="100%" height="100%" color="black" />
      </OuterContainer>
    );
  },
);

const OuterContainer = styled(Button)<{ backgroundColor: string; withShadow: boolean }>`
  background-color: ${(props) => props.backgroundColor};
  border: none;
  border-radius: 8px;
  cursor: pointer !important;
  box-shadow: ${(props) => (props.withShadow ? "0px 0px 3px 0px" : "none")};
  padding: 5px;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover:enabled {
    filter: brightness(115%);
  }
  &:active:enabled {
    filter: brightness(105%);
  }
  &:disabled {
    background-color: var(--divider);
    cursor: default !important;
  }
`;
